const API_HEADERS = {
  ACCOUNT_ID: "accountid",
  AUTHORIZATION: "Authorization"
};
export {
  API_HEADERS
};
